// Generated by CoffeeScript 1.10.0
(function() {
  var Filter;

  Filter = (function() {
    function Filter(context, key) {
      if (context && key) {
        Object.defineProperty(this, 'value', {
          get: function() {
            return context[key];
          }
        });
      }
    }

    Filter.prototype.process = function(buffer) {};

    return Filter;

  })();

  module.exports = Filter;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/av/src/filter.js
 ** module id = 547
 ** module chunks = 0
 **/